import { render, staticRenderFns } from "./TutoriaDetalle.vue?vue&type=template&id=112db607&"
import script from "./TutoriaDetalle.vue?vue&type=script&lang=js&"
export * from "./TutoriaDetalle.vue?vue&type=script&lang=js&"
import style0 from "./TutoriaDetalle.vue?vue&type=style&index=0&id=112db607&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports